// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9bfebe8e","545":"40d0d6f7"}[chunkId] + ".chunk.js";
};